import { NavigationItem, VerticalNavigationAppearance, verticalNavigationAppearanceArr } from '@red/components/navigation';

export type NavigationGroup = {
  [x in VerticalNavigationAppearance]?: NavigationItem[];
};
// export type NavigationGroup = Record<Partial<VerticalNavigationAppearance>,NavigationItem[]>
